import { createRuntimeFeatureFlags, DEFAULT_TENANT_ID, type FeatureKey, type RuntimeFeatureFlags, type TenantId, normalizeTenantId } from './types';

export const TENANT_FEATURES: Record<TenantId, RuntimeFeatureFlags> = {
  'trade-proof': {
    googleAuth: true,
    advancedReplayStats: true,
    aiCoach: true,
    exportCsv: true,
    regularCustomerFeedback: false,
  },
  'warrior-trading': {
    googleAuth: false,
    advancedReplayStats: false,
    aiCoach: false,
    exportCsv: false,
    regularCustomerFeedback: false,
  },
};

export function getFeatureFlagsForTenant(tenantId?: string | null): RuntimeFeatureFlags {
  const normalizedTenantId = normalizeTenantId(tenantId);
  const flags = TENANT_FEATURES[normalizedTenantId ?? DEFAULT_TENANT_ID];
  return createRuntimeFeatureFlags(flags);
}

export function isFeatureEnabled(features: Partial<RuntimeFeatureFlags> | null | undefined, featureKey: FeatureKey): boolean {
  return features?.[featureKey] === true;
}
